import './App.css';
import { Outlet, useLocation } from 'react-router-dom'; // 引入 useLocation
import { useLayoutEffect,useEffect  } from 'react';
import { safeArea } from './utils/safeArea';
import { setLanguage } from './i18n';
import BoosterNativeBridge from './jsBridge'
function App() {
    const location = useLocation();

    // 回到前台时向 Native 拉取当前语言并同步。
    // 从 Login 挪到 App：App 全程常驻，登录后 App 内切语言再切回也能跟随。
    useEffect(() => {
        const getNativeLocal = async () => {
            try {
                const result = await BoosterNativeBridge.getLocale();
                setLanguage(result.locale, { notifyNative: false });
                console.log('本地语言获取', result.locale); // "zh" 或 "en"
            } catch (error) {
                console.error("getNativeLocal:failed", error);
            }
        };

        window.addEventListener('focus', getNativeLocal);

        return () => {
            window.removeEventListener('focus', getNativeLocal);
        };
    }, []);

    useLayoutEffect(() => {
        console.log('🔥 App 挂载/路由切换，强制重新计算安全区域');

        // 🔥 关键：传入 true 强制计算，无视防抖
        // 这样能保证每次进入页面（包括重复进入）都立即获取最新值
        safeArea.calculate(true);

    }, [location.pathname]); // 🔥 依赖路径，路径变化时重新计算

    return (
        <div className="app-container App">
            <Outlet />
        </div>
    );
}

export default App;
